export default {
  'pages.login.success': 'Login realizado com sucesso!',
  'pages.login.failure': 'Falha no login, tente novamente!',
  'pages.login.username.placeholder': 'Nome de usuário',
  'pages.login.username.required': 'Por favor, informe seu nome de usuário!',
  'pages.login.password.placeholder': 'Senha',
  'pages.login.password.required': 'Por favor, informe sua senha!',
  'pages.login.rememberMe': 'Lembrar-me',
  'pages.login.forgotPassword': 'Esqueceu a senha?',
  'pages.login.forgotPasswordInfo':
    'Entre em contato com o administrador para redefinir a senha',
  'pages.login.submit': 'Entrar',
  'pages.login.back': 'Voltar',
  'pages.login.emailCheck.title': 'Verificação de E-mail',
  'pages.login.emailCheck.description':
    'Um código de 6 dígitos foi enviado para {email}',
  'pages.login.emailCheck.sent':
    'Um código de verificação foi enviado para seu e-mail',
  'pages.login.tfaCheck.title': 'Autenticação em Dois Fatores',
  'pages.login.tfaCheck.description':
    'Digite o código de 6 dígitos do seu aplicativo autenticador',
  'pages.login.verifyCode.submit': 'Verificar',
  'pages.login.verifyCode.invalid': 'Código de verificação inválido',
  'pages.login.oidc.divider': 'Ou continue com',
  'pages.login.oidc.continueWith': 'Continuar com {provider}',
  'pages.login.oidc.authFailed': 'Falha no login OIDC',
  'pages.devices.list': 'Lista de Dispositivos',
  'pages.devices.os': 'SO',
  'pages.devices.status': 'Status',
  'pages.devices.user': 'Usuário',
  'pages.devices.deviceGroup': 'Grupo',
  'pages.devices.note': 'Observação',
  'pages.devices.online': 'Online',
  'pages.devices.offline': 'Offline',
  'pages.devices.days': 'dias',
  'pages.devices.hours': 'horas',
  'pages.devices.minutes': 'minutos',
  'pages.devices.justNow': 'agora mesmo',
  'pages.devices.enable': 'Ativar',
  'pages.devices.disable': 'Desativar',
  'pages.devices.enableSuccess': 'Dispositivo ativado',
  'pages.devices.enableFailed': 'Falha ao ativar o dispositivo',
  'pages.devices.disableSuccess': 'Dispositivo desativado',
  'pages.devices.disableFailed': 'Falha ao desativar o dispositivo',
  'pages.devices.deleteSuccess': 'Dispositivo removido',
  'pages.devices.deleteFailed': 'Falha ao remover o dispositivo',
  'pages.devices.deleteConfirm':
    'Tem certeza de que deseja remover este dispositivo?',
  'pages.devices.deviceInfo': 'username@device_name',
  'pages.devices.strategyInfo': 'Informações da Estratégia',
  'pages.devices.device': 'Dispositivo',
  'pages.devices.strategy': 'Estratégia',
  'pages.devices.info': 'Informações',
  'pages.devices.statusNormal': 'Normal',
  'pages.devices.statusDisabled': 'Desativado',
  'pages.devices.onlineStatus': 'Status Online',
  'pages.devices.deviceGroupSearchTip':
    'Filtrar pelo nome do grupo de dispositivos',
  'pages.devices.remove': 'Remover',
  'pages.devices.removeFromGroupSuccess': 'Dispositivo removido do grupo',
  'pages.devices.removeFromGroupFailed':
    'Falha ao remover o dispositivo do grupo',
  'pages.devices.removeFromGroupConfirm':
    'Tem certeza de que deseja remover este dispositivo do grupo?',
  'pages.devices.batchRemove': 'Remoção em Lote',
  'pages.devices.batchRemoveFromGroupSuccess':
    '{count} dispositivo(s) removido(s) do grupo com sucesso',
  'pages.devices.batchRemoveFromGroupFailed':
    'Falha ao remover dispositivos do grupo',
  'pages.devices.batchRemoveFromGroupConfirm':
    'Tem certeza de que deseja remover os dispositivos selecionados do grupo?',
  'pages.devices.batchEnable': 'Ativar em Lote',
  'pages.devices.batchDisable': 'Desativar em Lote',
  'pages.devices.batchEnableConfirm':
    'Tem certeza de que deseja ativar os dispositivos selecionados?',
  'pages.devices.batchDisableConfirm':
    'Tem certeza de que deseja desativar os dispositivos selecionados?',
  'pages.devices.batchEnableSuccess':
    '{count} dispositivo(s) ativado(s) com sucesso',
  'pages.devices.batchEnableFailed': 'Falha ao ativar dispositivos',
  'pages.devices.batchEnablePartialFailed':
    '{success} dispositivo(s) ativado(s) com sucesso, {failed} falharam',
  'pages.devices.batchDisableSuccess':
    '{count} dispositivo(s) desativado(s) com sucesso',
  'pages.devices.batchDisableFailed': 'Falha ao desativar dispositivos',
  'pages.devices.batchDisablePartialFailed':
    '{success} dispositivo(s) desativado(s) com sucesso, {failed} falharam',
  'pages.devices.edit': 'Editar Dispositivo',
  'pages.devices.updateSuccess': 'Dispositivo atualizado',
  'pages.devices.updateFailed': 'Falha ao atualizar o dispositivo',
  'pages.devices.selectUser': 'Selecionar usuário',
  'pages.devices.selectDeviceGroup': 'Selecionar grupo de dispositivos',
  'pages.devices.selectStrategy': 'Selecionar estratégia',
  'pages.addressBook.name': 'Nome',
  'pages.addressBook.note': 'Observação',
  'pages.addressBook.shared': 'Catálogos de Endereços Compartilhados',
  'pages.addressBook.create': 'Criar Catálogo de Endereços',
  'pages.addressBook.edit': 'Editar Catálogo de Endereços',
  'pages.addressBook.personal': 'Catálogo de Endereços Pessoal',
  'pages.addressBook.currentAddressBook': 'Catálogo de endereços',
  'pages.addressBook.myAddressBook': 'Meu catálogo de endereços',
  'pages.addressBook.loadFailed': 'Falha ao carregar catálogos de endereços',
  'pages.addressBook.addPeer': 'Adicionar por ID',
  'pages.addressBook.addTag': 'Adicionar Tag',
  'pages.addressBook.tagName': 'Nome da Tag',
  'pages.addressBook.tagAdded': 'Tag adicionada',
  'pages.addressBook.tagAddFailed': 'Falha ao adicionar tag',
  'pages.addressBook.tagDeleted': 'Tag removida',
  'pages.addressBook.tagDeleteFailed': 'Falha ao remover a tag',
  'pages.addressBook.deleteTagConfirm':
    'Tem certeza de que deseja remover esta tag?',
  'pages.addressBook.tagModeUnion': 'Qualquer',
  'pages.addressBook.tagModeIntersection': 'Todos',
  'pages.addressBook.importDevices': 'Importar de Dispositivos',
  'pages.addressBook.importSuccess':
    '{count} dispositivo(s) importado(s) com sucesso',
  'pages.addressBook.importPartialFailed':
    '{count} dispositivo(s) falharam na importação',
  'pages.addressBook.createSuccess': 'Catálogo de endereços criado',
  'pages.addressBook.createFailed': 'Falha ao criar o catálogo de endereços',
  'pages.addressBook.updateSuccess': 'Catálogo de endereços atualizado',
  'pages.addressBook.updateFailed':
    'Falha ao atualizar o catálogo de endereços',
  'pages.addressBook.deleteSuccess': 'Catálogo(s) de endereços removido(s)',
  'pages.addressBook.deleteFailed': 'Falha ao remover catálogo(s) de endereços',
  'pages.addressBook.deleteConfirm':
    'Tem certeza de que deseja remover este catálogo de endereços?',
  'pages.addressBook.batchDeleteConfirm':
    'Tem certeza de que deseja remover os catálogos de endereços selecionados?',
  'pages.addressBook.device': 'Dispositivo',
  'pages.addressBook.alias': 'Alias',
  'pages.addressBook.tags': 'Tags',
  'pages.addressBook.peerAdded': 'Contato adicionado',
  'pages.addressBook.peerAddFailed': 'Falha ao adicionar contato',
  'pages.addressBook.peerDeleted': 'Contato removido',
  'pages.addressBook.peerDeleteFailed': 'Falha ao remover contato',
  'pages.addressBook.deletePeerConfirm':
    'Tem certeza de que deseja remover este contato?',
  'pages.addressBook.import': 'Importar de Dispositivos',
  'pages.addressBook.recycleBin': 'Lixeira',
  'pages.deviceGroups.list': 'Grupos de Dispositivos',
  'pages.deviceGroups.name': 'Nome',
  'pages.deviceGroups.note': 'Observação',
  'pages.deviceGroups.create': 'Criar Grupo de Dispositivos',
  'pages.deviceGroups.edit': 'Editar Grupo de Dispositivos',
  'pages.deviceGroups.createSuccess': 'Grupo de dispositivos criado',
  'pages.deviceGroups.createFailed': 'Falha ao criar grupo de dispositivos',
  'pages.deviceGroups.updateSuccess': 'Grupo de dispositivos atualizado',
  'pages.deviceGroups.updateFailed': 'Falha ao atualizar grupo de dispositivos',
  'pages.deviceGroups.deleteSuccess': 'Grupo de dispositivos removido',
  'pages.deviceGroups.deleteFailed': 'Falha ao remover grupo de dispositivos',
  'pages.deviceGroups.deleteConfirm':
    'Tem certeza de que deseja remover este grupo de dispositivos?',
  'pages.deviceGroups.import': 'Importar',
  'pages.deviceGroups.importDevices': 'Importar Dispositivos',
  'pages.deviceGroups.importSuccess':
    '{count} dispositivo(s) importado(s) com sucesso',
  'pages.deviceGroups.importFailed': 'Falha ao importar dispositivos',
  'pages.users.list': 'Lista de Usuários',
  'pages.users.name': 'Nome',
  'pages.users.displayName': 'Nome de Exibição',
  'pages.users.email': 'E-mail',
  'pages.users.note': 'Observação',
  'pages.users.status': 'Status',
  'pages.users.create': 'Criar Usuário',
  'pages.users.enable': 'Ativar',
  'pages.users.disable': 'Desativar',
  'pages.users.enableSuccess': 'Usuário ativado',
  'pages.users.enableFailed': 'Falha ao ativar usuário',
  'pages.users.disableSuccess': 'Usuário desativado',
  'pages.users.disableFailed': 'Falha ao desativar usuário',
  'pages.users.createSuccess': 'Usuário criado',
  'pages.users.createFailed': 'Falha ao criar usuário',
  'pages.users.deleteSuccess': 'Usuário removido',
  'pages.users.deleteFailed': 'Falha ao remover usuário',
  'pages.users.deleteConfirm':
    'Tem certeza de que deseja remover este usuário?',
  'pages.audits.conn': 'Auditoria de Conexões',
  'pages.audits.file': 'Logs de Transferência de Arquivos',
  'pages.audits.alarm': 'Auditoria de Alarmes',
  'pages.audits.console': 'Auditoria de Console',
  'pages.audits.requestedAt': 'Solicitado em',
  'pages.audits.establishedAt': 'Estabelecido em',
  'pages.audits.closedAt': 'Encerrado em',
  'pages.audits.from': 'Origem',
  'pages.audits.fromName': 'Nome de Origem',
  'pages.audits.to': 'Destino',
  'pages.audits.toName': 'Nome de Destino',
  'pages.audits.action': 'Ação',
  'pages.audits.time': 'Hora',
  'pages.audits.alarmType': 'Tipo de Alarme',
  'pages.audits.user': 'Usuário',
  'pages.audits.detail': 'Detalhes',
  'pages.audits.type': 'Tipo',
  'pages.audits.connType.remoteDesktop': 'Área de Trabalho Remota',
  'pages.audits.connType.fileTransfer': 'Transferência de Arquivos',
  'pages.audits.connType.portTransfer': 'Redirecionamento de Porta',
  'pages.audits.connType.viewCamera': 'Visualizar Câmera',
  'pages.audits.connType.terminal': 'Terminal',
  'pages.audits.connType.notLoggedIn': 'Não Autenticado',
  'pages.audits.duration': 'Duração',
  'pages.audits.note': 'Observação',
  'pages.audits.disconnect': 'Desconectar',
  'pages.audits.disconnectSuccess': 'Desconectado com sucesso!',
  'pages.audits.disconnectFailed': 'Falha ao desconectar!',
  'pages.audits.disconnectConfirmTitle': 'Confirmar Operação',
  'pages.audits.disconnectConfirmTip':
    'Tem certeza de que deseja desconectar este dispositivo?',
  'pages.audits.updateSuccess': 'Atualização realizada com sucesso',
  'pages.audits.updateFailed': 'Falha na atualização, tente novamente!',
  'pages.audits.exportCSV': 'Exportar CSV',
  'pages.audits.noDataToExport': 'Nenhum dado para exportar',
  'pages.audits.exportSuccess': 'Exportação concluída com sucesso',
  'pages.audits.exportFailed': 'Falha na exportação',
  'pages.audits.exportConfirmTitle': 'Exportar CSV',
  'pages.audits.exportConfirmContent':
    'Exportar até 1000 registros. Deseja continuar?',
  'pages.audits.remote': 'Remoto',
  'pages.audits.local': 'Local',
  'pages.audits.direction': 'Direção',
  'pages.audits.files': 'Arquivos',
  'pages.audits.remoteTip': 'Computador ou terminal controlado remotamente',
  'pages.audits.remoteSearchTip':
    'Pesquisar por ID do dispositivo remoto (correspondência parcial)',
  'pages.audits.remotePlaceholder': 'Digite o ID do dispositivo remoto',
  'pages.audits.pathTip': 'Caminho do Dispositivo Remoto',
  'pages.audits.exportCsvTip': 'Exporte até 1000 registros por vez',
  'pages.audits.limitedTip': 'Exibir os 10 maiores arquivos por tamanho',
  'pages.audits.startTime': 'Hora de Início',
  'pages.audits.endTime': 'Hora de Término',
  'pages.audits.alarmType.ipWhitelist': 'IP Não Está na Lista Branca',
  'pages.audits.alarmType.exceedThirtyAttempts':
    'O Mesmo IP Excedeu 30 Tentativas Sem Sucesso',
  'pages.audits.alarmType.sixAttemptsWithinOneMinute':
    'Mais de 6 Tentativas em 1 Minuto',
  'pages.audits.alarmType.exceedIpv6PrefixAttempts':
    'Limite de Tentativas do Prefixo IPv6 Excedido',
  'pages.audits.alarmType.terminalOsLoginBackoff':
    'Login do Sistema Operacional Bloqueado por Backoff',
  'pages.audits.alarmType.terminalOsLoginConcurrency':
    'Limite de Concorrência de Login do Sistema Operacional Excedido',
  'pages.common.action': 'Ação',
  'pages.common.delete': 'Excluir',
  'pages.common.edit': 'Editar',
  'pages.common.batchDelete': 'Excluir em Lote',
  'pages.common.download': 'Baixar',
  'pages.common.more': 'Mais',
  'pages.404.subTitle': 'Desculpe, a página que você visitou não existe',
  'pages.404.buttonText': 'Voltar para a Página Inicial',
  'pages.customClients.list': 'Lista de Clientes Personalizados',
  'pages.customClients.name': 'Nome do Cliente',
  'pages.customClients.createdAt': 'Criado em',
  'pages.customClients.create': 'Criar Cliente Personalizado',
  'pages.customClients.edit': 'Editar Cliente Personalizado',
  'pages.customClients.deleteConfirm':
    'Tem certeza de que deseja excluir este cliente personalizado?',
  'pages.customClients.createSuccess': 'Cliente personalizado criado',
  'pages.customClients.createFailed': 'Falha ao criar cliente personalizado',
  'pages.customClients.updateSuccess': 'Cliente personalizado atualizado',
  'pages.customClients.updateFailed':
    'Falha ao atualizar cliente personalizado',
  'pages.customClients.deleteSuccess': 'Cliente personalizado excluído',
  'pages.customClients.deleteFailed': 'Falha ao excluir cliente personalizado',
  'pages.customClients.downloadFailed': 'Falha ao baixar o cliente',
  'pages.userGroups.list': 'Lista de Grupos de Usuários',
  'pages.userGroups.name': 'Nome do Grupo',
  'pages.userGroups.note': 'Observação',
  'pages.userGroups.userCount': 'Quantidade de Usuários',
  'pages.userGroups.create': 'Criar Grupo de Usuários',
  'pages.userGroups.edit': 'Editar Grupo de Usuários',
  'pages.userGroups.deleteConfirm':
    'Tem certeza de que deseja excluir este grupo de usuários?',
  'pages.userGroups.createSuccess': 'Grupo de usuários criado',
  'pages.userGroups.createFailed': 'Falha ao criar grupo de usuários',
  'pages.userGroups.updateSuccess': 'Grupo de usuários atualizado',
  'pages.userGroups.updateFailed': 'Falha ao atualizar grupo de usuários',
  'pages.userGroups.deleteSuccess': 'Grupo de usuários excluído',
  'pages.userGroups.deleteFailed': 'Falha ao excluir grupo de usuários',
  'pages.userGroups.loadFailed': 'Falha ao carregar grupos de usuários',
  'pages.userGroups.default': 'Padrão',
  'pages.userGroups.members': 'Membros',
  'pages.userGroups.membersTitle': 'Membros de {name}',
  'pages.userGroups.currentMembers': 'Membros atuais',
  'pages.userGroups.addUsers': 'Adicionar usuários',
  'pages.userGroups.destination': 'Grupo de destino',
  'pages.userGroups.selectDestination': 'Selecione o grupo de destino',
  'pages.userGroups.moveSelected': 'Mover selecionados',
  'pages.userGroups.addSelected': 'Adicionar usuários selecionados',
  'pages.userGroups.membersUpdated': '{count} usuário(s) atualizado(s)',
  'pages.userGroups.membersUpdateFailed': 'Falha ao atualizar membros do grupo',
  'pages.users.userGroup': 'Grupo de Usuários',
  'pages.users.selectUserGroup': 'Selecione o grupo de usuários',
  'pages.addressBook.groupAccess': 'Acesso por grupo',
  'pages.addressBook.groupAccessTitle': 'Acesso por grupo de {name}',
  'pages.addressBook.userGroup': 'Grupo de usuários',
  'pages.addressBook.permission': 'Permissão',
  'pages.addressBook.permissionRead': 'Somente leitura',
  'pages.addressBook.permissionReadWrite': 'Leitura e escrita',
  'pages.addressBook.permissionFull': 'Controle total',
  'pages.addressBook.addGroupAccess': 'Adicionar acesso por grupo',
  'pages.addressBook.groupAccessLoadFailed':
    'Falha ao carregar acesso por grupo',
  'pages.addressBook.groupAccessAdded': 'Acesso por grupo adicionado',
  'pages.addressBook.groupAccessAddFailed':
    'Falha ao adicionar acesso por grupo',
  'pages.addressBook.groupAccessUpdated': 'Acesso por grupo atualizado',
  'pages.addressBook.groupAccessUpdateFailed':
    'Falha ao atualizar acesso por grupo',
  'pages.addressBook.groupAccessDeleted': 'Acesso por grupo excluído',
  'pages.addressBook.groupAccessDeleteFailed':
    'Falha ao excluir acesso por grupo',
  'pages.addressBook.groupAccessDeleteConfirm':
    'Excluir este acesso por grupo?',
  'pages.addressBook.shareAccess': 'Compartilhar',
  'pages.addressBook.accessTitle': '{name} - Gerenciamento de acesso',
  'pages.addressBook.shareType': 'Tipo de compartilhamento',
  'pages.addressBook.shareTarget': 'Destino',
  'pages.addressBook.shareTypeEveryone': 'Todos',
  'pages.addressBook.shareTypeUser': 'Usuário',
  'pages.addressBook.shareTypeGroup': 'Grupo de usuários',
  'pages.addressBook.selectUser': 'Selecionar usuário',
  'pages.addressBook.selectUserPlaceholder':
    'Pesquisar por nome de usuário ou e-mail',
  'pages.addressBook.everyoneHint':
    'Todos os usuários terão acesso a este catálogo de endereços',
  'pages.addressBook.allUsers': 'Todos os usuários',
  'pages.addressBook.addAccess': 'Adicionar acesso',
  'pages.addressBook.accessLoadFailed': 'Falha ao carregar regras de acesso',
  'pages.addressBook.accessAdded': 'Regra de acesso adicionada',
  'pages.addressBook.accessAddFailed': 'Falha ao adicionar regra de acesso',
  'pages.addressBook.accessUpdated': 'Regra de acesso atualizada',
  'pages.addressBook.accessUpdateFailed': 'Falha ao atualizar regra de acesso',
  'pages.addressBook.accessDeleted': 'Regra de acesso excluída',
  'pages.addressBook.accessDeleteFailed': 'Falha ao excluir regra de acesso',
  'pages.addressBook.accessDeleteConfirm': 'Excluir esta regra de acesso?',
  'pages.roles.list': 'Lista de Funções',
  'pages.roles.name': 'Nome da Função',
  'pages.roles.note': 'Observação',
  'pages.roles.permissions': 'Permissões',
  'pages.roles.permissionsInfo': 'Número de permissões atribuídas',
  'pages.roles.create': 'Criar Função',
  'pages.roles.edit': 'Editar Função',
  'pages.roles.deleteConfirm': 'Tem certeza de que deseja excluir esta função?',
  'pages.roles.selectPermissions': 'Selecionar Permissões',
  'pages.roles.createSuccess': 'Função criada com sucesso',
  'pages.roles.createFailed': 'Falha ao criar função',
  'pages.roles.updateSuccess': 'Função atualizada com sucesso',
  'pages.roles.updateFailed': 'Falha ao atualizar função',
  'pages.roles.deleteSuccess': 'Função excluída com sucesso',
  'pages.roles.deleteFailed': 'Falha ao excluir função',
  'pages.settings.title': 'Configurações do Sistema',
  'pages.settings.save': 'Salvar Configurações',
  'pages.settings.general': 'Configurações Gerais',
  'pages.settings.siteName': 'Nome do Site',
  'pages.settings.watermarkEnabled': "Marca d'agua com nome de usuario",
  'pages.settings.adminEmail': 'E-mail do Administrador',
  'pages.settings.language': 'Idioma Padrão',
  'pages.settings.security': 'Configurações de Segurança',
  'pages.settings.enable2FA': 'Ativar Autenticação em Dois Fatores',
  'pages.settings.sessionTimeout': 'Tempo Limite da Sessão (minutos)',
  'pages.settings.maxLoginAttempts': 'Máximo de Tentativas de Login',
  'pages.settings.advanced': 'Configurações Avançadas',
  'pages.settings.logLevel': 'Nível de Log',
  'pages.settings.enableDebugMode': 'Ativar Modo de Depuração',
  'pages.settings.fetchFailed': 'Falha ao carregar configurações',
  'pages.settings.saveSuccess': 'Configurações salvas com sucesso',
  'pages.settings.saveFailed': 'Falha ao salvar configurações',
  'pages.strategies.list': 'Lista de Estratégias',
  'pages.strategies.name': 'Nome da Estratégia',
  'pages.strategies.note': 'Observação',
  'pages.strategies.status': 'Status',
  'pages.strategies.create': 'Criar Estratégia',
  'pages.strategies.edit': 'Editar Estratégia',
  'pages.strategies.deleteConfirm':
    'Tem certeza de que deseja excluir esta estratégia?',
  'pages.strategies.createSuccess': 'Estratégia criada',
  'pages.strategies.createFailed': 'Falha ao criar estratégia',
  'pages.strategies.updateSuccess': 'Estratégia atualizada',
  'pages.strategies.updateFailed': 'Falha ao atualizar estratégia',
  'pages.strategies.deleteSuccess': 'Estratégia removida',
  'pages.strategies.deleteFailed': 'Falha ao remover estratégia',
  'pages.strategies.enterName': 'Digite o nome da estratégia',
  'pages.strategies.configSummary': 'Configuração',
  'pages.strategies.configCount': '{modified}/{total} modificadas',
  'pages.strategies.modifiedAt': 'Modificado em',
  'pages.strategies.createdAt': 'Criado em',
  'pages.strategies.configOptions': 'Opções de Configuração',
  'pages.strategies.defaultLabel': 'Padrão',
  'pages.strategies.defaultValue': 'Padrão: {value}',
  'pages.strategies.resetToDefault': 'Restaurar padrão',
  'pages.strategies.modifiedSummary': '{count} configuração(ões) modificada(s)',
  'pages.strategies.resetAll': 'Restaurar Tudo',
  'pages.strategies.assign': 'Atribuir',
  'pages.strategies.assignManagement': 'Gerenciamento de Atribuições',
  'pages.strategies.assignDevice': 'Dispositivo',
  'pages.strategies.assignUser': 'Usuário',
  'pages.strategies.assignDeviceGroup': 'Grupo de Dispositivos',
  'pages.strategies.assignedTargets': 'Destinos Atribuídos',
  'pages.strategies.noAssigned': 'Nenhum destino atribuído',
  'pages.strategies.addAssignment': 'Adicionar Atribuição',
  'pages.strategies.selectTarget': 'Selecionar destino',
  'pages.strategies.assignSuccess': 'Estratégia atribuída com sucesso',
  'pages.strategies.assignFailed': 'Falha ao atribuir estratégia',
  'pages.strategies.assignPartialFailed':
    '{success} destino(s) atribuído(s), {failed} falharam: {errors}',
  'pages.strategies.unassignSuccess': 'Estratégia removida com sucesso',
  'pages.strategies.unassignFailed':
    'Falha ao remover atribuição da estratégia',
  'pages.strategies.unassignConfirm': 'Remover atribuição deste destino?',
  'pages.strategies.fetchDetailFailed': 'Falha ao obter detalhes da estratégia',
  'pages.strategies.updatedAt': 'Atualizado em',
  'pages.strategies.category.connection': 'Conexão e Acesso',
  'pages.strategies.category.security': 'Segurança e Autenticação',
  'pages.strategies.category.display': 'Tela e Interface',
  'pages.strategies.category.av': 'Áudio, Vídeo e Codec',
  'pages.strategies.category.file': 'Arquivos e Área de Transferência',
  'pages.strategies.category.advanced': 'Avançado',
  'pages.strategies.category.floating': 'Janela Flutuante',
  'pages.strategies.category.privacy': 'Privacidade e Gravação',
  'pages.strategies.category.hide': 'Ocultação da Interface',
  'pages.users.inviteSuccess': 'Convite enviado',
  'pages.users.inviteFailed': 'Falha ao enviar convite',
  'pages.users.active': 'Ativo',
  'pages.users.disabled': 'Desativado',
  'pages.users.unverified': 'Não Verificado',
  'pages.users.roles': 'Funções',
  'pages.users.rolesInfo': 'Funções e permissões do usuário',
  'pages.users.strategy': 'Estratégia',
  'pages.users.strategyInfo': 'Estratégia de conexão do usuário',
  'pages.users.group': 'Grupo',
  'pages.users.groupInfo': 'Atribuição de grupo do usuário',
  'pages.users.groupName': 'Grupo de Dispositivos',
  'pages.users.invite': 'Convidar Usuário',
  'pages.users.password': 'Senha',
  'pages.users.isAdmin': 'Administrador',
  'pages.users.normalUser': 'Normal',
  'pages.users.statusInfo': 'Status da conta do usuário',
  'pages.users.edit': 'Editar Usuário',
  'pages.users.updateSuccess': 'Usuário atualizado',
  'pages.users.updateFailed': 'Falha ao atualizar usuário',
  'pages.users.security': 'Segurança',
  'pages.users.securitySettings': 'Configurações de Segurança',
  'pages.users.securityUpdateSuccess': 'Configurações de segurança atualizadas',
  'pages.users.securityUpdateFailed':
    'Falha ao atualizar configurações de segurança',
  'pages.users.tfaEnforce': 'Exigir Autenticação em Dois Fatores',
  'pages.users.emailVerification': 'Exigir Verificação por E-mail',
  'pages.users.forceLogout': 'Encerrar Sessão',
  'pages.users.forceLogoutSuccess': 'Sessão encerrada com sucesso',
  'pages.users.forceLogoutFailed': 'Falha ao encerrar sessão',
  'pages.users.thirdAuthType': 'Tipo de Autenticação',
  'pages.users.createdAt': 'Criado em',
  'pages.users.batchEnable': 'Ativar em Lote',
  'pages.users.batchDisable': 'Desativar em Lote',
  'pages.users.batchForceLogout': 'Encerrar Sessões em Lote',
  'pages.users.batchEnableConfirm':
    'Tem certeza de que deseja ativar os usuários selecionados?',
  'pages.users.batchDisableConfirm':
    'Tem certeza de que deseja desativar os usuários selecionados?',
  'pages.users.batchForceLogoutConfirm':
    'Tem certeza de que deseja encerrar a sessão dos usuários selecionados?',
  'pages.users.batchEnableSuccess': '{count} usuário(s) ativado(s) com sucesso',
  'pages.users.batchEnableFailed': 'Falha ao ativar usuários',
  'pages.users.batchEnablePartialFailed':
    '{success} usuário(s) ativado(s) com sucesso, {failed} falharam',
  'pages.users.batchDisableSuccess':
    '{count} usuário(s) desativado(s) com sucesso',
  'pages.users.batchDisableFailed': 'Falha ao desativar usuários',
  'pages.users.batchDisablePartialFailed':
    '{success} usuário(s) desativado(s) com sucesso, {failed} falharam',
  'pages.users.batchForceLogoutSuccess':
    'Encerramento de sessões em lote realizado com sucesso',
  'pages.users.batchForceLogoutFailed':
    'Falha ao encerrar sessões dos usuários',
  'pages.dashboard.totalUsers': 'Total de Usuários',
  'pages.dashboard.activeUsers': 'Usuários Ativos',
  'pages.dashboard.totalDevices': 'Total de Dispositivos',
  'pages.dashboard.onlineDevices': 'Dispositivos Online',
  'pages.dashboard.offlineDevices': 'Dispositivos Offline',
  'pages.dashboard.todayConnections': 'Conexões Hoje',
  'pages.dashboard.activeConnections': 'Conexões Ativas',
  'pages.dashboard.avgDuration': 'Duração Média',
  'pages.dashboard.totalAlarms': 'Total de Alarmes',
  'pages.dashboard.criticalAlarms': 'Alarmes Críticos',
  'pages.dashboard.userDistribution': 'Distribuição de Usuários',
  'pages.dashboard.adminUsers': 'Usuários Administradores',
  'pages.dashboard.normalUsers': 'Usuários Comuns',
  'pages.dashboard.deviceDistribution': 'Distribuição de Dispositivos',
  'pages.dashboard.connectionAnalysis': 'Análise de Conexões',
  'pages.dashboard.successRate': 'Taxa de Sucesso',
  'pages.dashboard.failureCount': 'Quantidade de Falhas',
  'pages.dashboard.totalDuration': 'Duração Total',
  'pages.dashboard.fileTransfer': 'Transferência de Arquivos',
  'pages.dashboard.transferredToday': 'Transferido Hoje',
  'pages.dashboard.totalSize': 'Tamanho Total',
  'pages.dashboard.uploadCount': 'Quantidade de Uploads',
  'pages.dashboard.downloadCount': 'Quantidade de Downloads',
  'pages.dashboard.systemStatus': 'Status do Sistema',
  'pages.dashboard.uptime': 'Tempo de Atividade',
  'pages.dashboard.trendData': 'Dados de Tendência',
  'pages.dashboard.connectionTrend': 'Tendência de Conexões',
  'pages.dashboard.userActiveTrend': 'Tendência de Atividade dos Usuários',
  'pages.dashboard.alarmTrend': 'Tendência de Alarmes',
  'pages.dashboard.recentEvents': 'Eventos Recentes',
  'pages.dashboard.user': 'Usuário',
  'pages.dashboard.device': 'Dispositivo',
  'pages.dashboard.duration': 'Duração',
  'pages.dashboard.startTime': 'Hora de Início',
  'pages.dashboard.eventType': 'Tipo',
  'pages.dashboard.action': 'Ação',
  'pages.dashboard.target': 'Destino',
  'pages.dashboard.status': 'Status',
  'pages.dashboard.time': 'Hora',
  'pages.common.pleaseEnterName': 'Por favor, informe o nome',
  'pages.common.pleaseEnterId': 'Por favor, informe o ID',
  'pages.common.pleaseEnterTagName': 'Por favor, informe o nome da tag',
  'pages.common.pleaseEnterUsername': 'Por favor, informe o nome de usuário',
  'pages.common.pleaseEnterEmail': 'Por favor, informe o e-mail',
  'pages.common.pleaseEnterValidEmail': 'Por favor, informe um e-mail válido',
  'pages.common.pleaseEnterPassword': 'Por favor, informe a senha',
  'pages.common.pleaseEnterRoleName': 'Por favor, informe o nome da função',
  'pages.common.id': 'ID',
  'pages.dashboard.min': 'min',
  'pages.dashboard.cpu': 'CPU',
  'pages.dashboard.memory': 'Memória',
  'pages.dashboard.disk': 'Disco',
  'pages.dashboard.inactive': 'Inativo',
  'pages.dashboard.onlineRate': 'Taxa Online',
  'pages.dashboard.connectionCount': 'Quantidade',
  'pages.dashboard.newUsers': 'Novos Usuários',
  'pages.dashboard.7days': '7 Dias',
  'pages.dashboard.30days': '30 Dias',
  'pages.dashboard.90days': '90 Dias',
  'pages.dashboard.noData': 'Nenhum dado',
  'pages.dashboard.resourceDistribution': 'Distribuição de Recursos',
  'pages.dashboard.operationAnalysis': 'Análise de Operações',
  'pages.smtp.title': 'Configuração SMTP',
  'pages.smtp.description':
    'Configure o servidor SMTP para envio de e-mails de notificação do sistema',
  'pages.smtp.host': 'Endereço do Servidor',
  'pages.smtp.hostPlaceholder': 'Informe o endereço do servidor SMTP',
  'pages.smtp.port': 'Porta',
  'pages.smtp.portPlaceholder': 'Informe o número da porta',
  'pages.smtp.secure': 'Usar SSL/TLS',
  'pages.smtp.secureHelp':
    'Ativa conexão segura (normalmente a porta 465 usa SSL e a 587 usa TLS)',
  'pages.smtp.user': 'Nome de Usuário',
  'pages.smtp.userPlaceholder': 'Informe o usuário de autenticação SMTP',
  'pages.smtp.password': 'Senha',
  'pages.smtp.passwordPlaceholder': 'Informe a senha de autenticação SMTP',
  'pages.smtp.from': 'E-mail do Remetente',
  'pages.smtp.fromPlaceholder': 'Informe o endereço de e-mail do remetente',
  'pages.smtp.enabled': 'Ativar Configuração',
  'pages.smtp.enabledHelp':
    'Quando ativada, esta configuração será utilizada para enviar e-mails do sistema',
  'pages.smtp.testConnection': 'Testar Conexão',
  'pages.smtp.testSuccess': 'Teste de conexão SMTP realizado com sucesso',
  'pages.smtp.testFailed': 'Falha no teste de conexão SMTP',
  'pages.smtp.saveSuccess': 'Configuração SMTP salva com sucesso',
  'pages.smtp.saveFailed': 'Falha ao salvar configuração SMTP',
  'pages.smtp.createdAt': 'Criado em',
  'pages.smtp.updatedAt': 'Atualizado em',
  'pages.addressBook.color': 'Cor',
  'pages.addressBook.deviceInfo': 'username@device_name',
  'pages.addressBook.manageTags': 'Gerenciar Tags',
  'pages.addressBook.newTagName': 'Nome da Nova Tag',
  'pages.addressBook.peerUpdateFailed': 'Falha ao atualizar contato',
  'pages.addressBook.peerUpdated': 'Contato atualizado',
  'pages.addressBook.renameTag': 'Renomear Tag',
  'pages.addressBook.selectTags': 'Selecionar tags',
  'pages.addressBook.tagColorUpdateFailed': 'Falha ao atualizar a cor da tag',
  'pages.addressBook.tagRenameFailed': 'Falha ao renomear tag',
  'pages.addressBook.tagRenamed': 'Tag renomeada',
  'pages.addressBook.untagged': 'Sem Tag',
  'pages.common.cancel': 'Não',
  'pages.common.confirm': 'Sim',
  'pages.common.enterDescription': 'Informe uma descrição',
  'pages.common.rename': 'Renomear',
  'pages.common.save': 'Salvar',
  'pages.customClients.enterName': 'Informe o nome do cliente',
  'pages.settings.chinese': 'Chinês',
  'pages.settings.english': 'Inglês',
  'pages.settings.enterAdminEmail': 'Informe o e-mail do administrador',
  'pages.settings.enterSiteName': 'Informe o nome do site',
  'pages.settings.logError': 'Erro',
  'pages.settings.logInfo': 'Informação',
  'pages.settings.logWarning': 'Aviso',
  'pages.userGroups.enterName': 'Informe o nome do grupo',
  'pages.users.admin': 'Administrador',
  'pages.users.me': 'Eu',
  'pages.oidcProviders.list': 'Provedores OIDC',
  'pages.oidcProviders.sort': 'Ordenar',
  'pages.oidcProviders.name': 'Nome do Provedor',
  'pages.oidcProviders.type': 'Tipo',
  'pages.oidcProviders.issuer': 'URL do Emissor',
  'pages.oidcProviders.clientId': 'ID do Cliente',
  'pages.oidcProviders.clientSecret': 'Segredo do Cliente',
  'pages.oidcProviders.scope': 'Escopo',
  'pages.oidcProviders.authorizationEndpoint': 'Endpoint de Autorização',
  'pages.oidcProviders.tokenEndpoint': 'Endpoint de Token',
  'pages.oidcProviders.userinfoEndpoint': 'Endpoint de Informações do Usuário',
  'pages.oidcProviders.jwksUri': 'URI JWKS',
  'pages.oidcProviders.enabled': 'Ativado',
  'pages.oidcProviders.priority': 'Prioridade',
  'pages.oidcProviders.endpointConfig': 'Configuração dos Endpoints',
  'pages.oidcProviders.create': 'Criar Provedor',
  'pages.oidcProviders.edit': 'Editar Provedor',
  'pages.oidcProviders.test': 'Testar',
  'pages.oidcProviders.testResult': 'Resultado do Teste de Conexão',
  'pages.oidcProviders.discoveredEndpoints': 'Endpoints Descobertos',
  'pages.oidcProviders.enterName': 'Informe o nome do provedor',
  'pages.oidcProviders.enterIssuer': 'Informe a URL do emissor',
  'pages.oidcProviders.enterClientId': 'Informe o ID do cliente',
  'pages.oidcProviders.enterClientSecret': 'Informe o segredo do cliente',
  'pages.oidcProviders.enterEndpoint': 'Descoberto automaticamente se vazio',
  'pages.oidcProviders.createSuccess': 'Provedor OIDC criado',
  'pages.oidcProviders.createFailed': 'Falha ao criar provedor OIDC',
  'pages.oidcProviders.updateSuccess': 'Provedor OIDC atualizado',
  'pages.oidcProviders.updateFailed': 'Falha ao atualizar provedor OIDC',
  'pages.oidcProviders.deleteSuccess': 'Provedor OIDC removido',
  'pages.oidcProviders.deleteFailed': 'Falha ao remover provedor OIDC',
  'pages.oidcProviders.deleteConfirm':
    'Tem certeza de que deseja remover este provedor?',
  'pages.oidcProviders.enableSuccess': 'Provedor OIDC ativado',
  'pages.oidcProviders.enableFailed': 'Falha ao ativar provedor OIDC',
  'pages.oidcProviders.disableSuccess': 'Provedor OIDC desativado',
  'pages.oidcProviders.disableFailed': 'Falha ao desativar provedor OIDC',
  'pages.oidcProviders.enableConfirm':
    'Tem certeza de que deseja ativar este provedor?',
  'pages.oidcProviders.disableConfirm':
    'Tem certeza de que deseja desativar este provedor?',
  'pages.oidcProviders.testFailed': 'Falha ao testar conexão OIDC',
  'pages.oidcProviders.sortFailed': 'Falha ao atualizar ordem dos provedores',
  'pages.oidcProviders.fetchDetailFailed':
    'Falha ao obter detalhes do provedor',
  'pages.account.tab.basic': 'Informações Básicas',
  'pages.account.tab.avatar': 'Avatar',
  'pages.account.tab.security': 'Segurança',
  'pages.account.basicInfo.title': 'Informações Básicas',
  'pages.account.basicInfo.displayName': 'Nome de Exibição',
  'pages.account.basicInfo.displayNamePlaceholder': 'Digite o nome de exibição',
  'pages.account.basicInfo.name': 'Nome de Usuário',
  'pages.account.basicInfo.email': 'E-mail',
  'pages.account.basicInfo.note': 'Observação',
  'pages.account.basicInfo.updateSuccess': 'Perfil atualizado com sucesso',
  'pages.account.basicInfo.updateFailed': 'Falha ao atualizar perfil',
  'pages.account.avatar.title': 'Configurações do Avatar',
  'pages.account.avatar.hint':
    'Suporta JPG, PNG e WebP, tamanho máximo de 2 MB, será redimensionado para 256x256',
  'pages.account.avatar.upload': 'Enviar Avatar',
  'pages.account.avatar.delete': 'Remover Avatar',
  'pages.account.avatar.deleteConfirm':
    'Tem certeza de que deseja remover seu avatar?',
  'pages.account.avatar.uploadSuccess': 'Avatar enviado com sucesso',
  'pages.account.avatar.uploadFailed': 'Falha ao enviar avatar',
  'pages.account.avatar.deleteSuccess': 'Avatar removido com sucesso',
  'pages.account.avatar.deleteFailed': 'Falha ao remover avatar',
  'pages.account.avatar.fileTooLarge':
    'O tamanho do arquivo não pode exceder 2 MB',
  'pages.account.avatar.invalidFormat':
    'Apenas os formatos JPG, PNG e WebP são suportados',
  'pages.account.security.title': 'Configurações de Segurança',
  'pages.account.security.2faStatus': 'Status do 2FA',
  'pages.account.security.2faAction': 'Ação',
  'pages.account.security.enabled': 'Ativado',
  'pages.account.security.disabled': 'Desativado',
  'pages.account.security.enable2FA': 'Ativar 2FA',
  'pages.account.security.disable2FA': 'Desativar 2FA',
  'pages.account.security.setup2FA': 'Configurar Autenticação em Dois Fatores',
  'pages.account.security.setupFailed': 'Falha ao configurar 2FA',
  'pages.account.security.scanQRCode':
    'Escaneie o código QR com seu aplicativo autenticador e depois informe o código de verificação abaixo.',
  'pages.account.security.secretKey': 'Chave Secreta',
  'pages.account.security.verificationCode': 'Código de Verificação',
  'pages.account.security.enterCode': 'Informe o código de verificação',
  'pages.account.security.verifyAndEnable': 'Verificar e Ativar',
  'pages.account.security.enableSuccess': '2FA ativado com sucesso',
  'pages.account.security.enableFailed': 'Falha ao ativar 2FA',
  'pages.account.security.currentCode': 'Código de Verificação Atual',
  'pages.account.security.confirmDisable': 'Confirmar Desativação',
  'pages.account.security.disableSuccess': '2FA desativado com sucesso',
  'pages.account.security.disableFailed': 'Falha ao desativar 2FA',
  'pages.account.security.password': 'Senha de Login',
  'pages.account.security.passwordSet': 'Configurada',
  'pages.account.security.passwordNotSet': 'Não Configurada',
  'pages.account.security.changePassword': 'Alterar Senha',
  'pages.account.security.currentPassword': 'Senha Atual',
  'pages.account.security.enterCurrentPassword': 'Informe a senha atual',
  'pages.account.security.newPassword': 'Nova Senha',
  'pages.account.security.enterNewPassword':
    'Informe a nova senha (mínimo de 6 caracteres)',
  'pages.account.security.confirmNewPassword': 'Confirmar Nova Senha',
  'pages.account.security.confirmNewPasswordPlaceholder':
    'Informe novamente a nova senha',
  'pages.account.security.passwordMinLength':
    'A senha deve ter pelo menos 6 caracteres',
  'pages.account.security.passwordMismatch': 'As duas senhas não coincidem',
  'pages.account.security.changePasswordSuccess': 'Senha alterada com sucesso',
  'pages.account.security.changePasswordFailed': 'Falha ao alterar senha',
  'pages.account.security.thirdPartyUser':
    'Usuários autenticados por terceiros não podem alterar a senha',
  'pages.account.security.noPasswordUser':
    'Nenhuma senha configurada para esta conta',
  'pages.ldap.title': 'Configuração LDAP',
  'pages.ldap.description':
    'Configure a autenticação LDAP/Active Directory. Quando ativado, os usuários serão autenticados automaticamente via LDAP.',
  'pages.ldap.urls': 'URLs do Servidor',
  'pages.ldap.urlsRequired': 'Informe pelo menos uma URL de servidor LDAP',
  'pages.ldap.urlPlaceholder': 'ex.: ldaps://ad.exemplo.com:636',
  'pages.ldap.addUrl': 'Adicionar URL do Servidor',
  'pages.ldap.bindDN': 'DN de Vinculação',
  'pages.ldap.bindDNRequired': 'Informe o DN da conta de serviço',
  'pages.ldap.bindDNPlaceholder':
    'ex.: CN=svc-ldap,OU=ServiceAccounts,DC=example,DC=com',
  'pages.ldap.bindCredentials': 'Senha de Vinculação',
  'pages.ldap.bindCredentialsRequired': 'Informe a senha da conta de serviço',
  'pages.ldap.bindCredentialsPlaceholder':
    'Informe a senha da conta de serviço',
  'pages.ldap.searchBase': 'DN Base de Pesquisa',
  'pages.ldap.searchBaseRequired': 'Informe o DN base de pesquisa',
  'pages.ldap.searchBasePlaceholder': 'ex.: DC=example,DC=com',
  'pages.ldap.searchFilter': 'Filtro de Pesquisa',
  'pages.ldap.searchFilterRequired': 'Informe o filtro de pesquisa',
  'pages.ldap.searchFilterHelp':
    'Use {{username}} como marcador do nome de usuário. AD: (sAMAccountName={{username}}), OpenLDAP: (uid={{username}})',
  'pages.ldap.searchFilterPlaceholder': 'ex.: (sAMAccountName={{username}})',
  'pages.ldap.searchAttributes': 'Atributos de Pesquisa',
  'pages.ldap.searchAttributePlaceholder':
    'ex.: dn, sAMAccountName, mail, displayName',
  'pages.ldap.addAttribute': 'Adicionar Atributo',
  'pages.ldap.groupSearchBase': 'DN Base de Pesquisa de Grupos',
  'pages.ldap.groupSearchBasePlaceholder': 'ex.: OU=Groups,DC=example,DC=com',
  'pages.ldap.groupSearchFilter': 'Filtro de Pesquisa de Grupo',
  'pages.ldap.groupSearchFilterHelp':
    'Use {{dn}} como marcador do DN do usuário. Ex.: (member={{dn}})',
  'pages.ldap.groupSearchFilterPlaceholder': 'ex.: (member={{dn}})',
  'pages.ldap.adminGroups': 'Grupos Administradores',
  'pages.ldap.adminGroupsHelp':
    'Usuários desses grupos LDAP serão mapeados como administradores (comparação sem diferenciar maiúsculas e minúsculas)',
  'pages.ldap.adminGroupPlaceholder':
    'ex.: CN=Admins,OU=Groups,DC=example,DC=com',
  'pages.ldap.addAdminGroup': 'Adicionar Grupo Administrador',
  'pages.ldap.tlsOptions': 'Opções TLS',
  'pages.ldap.tlsCa': 'Certificado CA (PEM)',
  'pages.ldap.tlsCaPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsCert': 'Certificado do Cliente (PEM)',
  'pages.ldap.tlsCertPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsKey': 'Chave Privada do Cliente (PEM)',
  'pages.ldap.tlsKeyPlaceholder': '-----BEGIN PRIVATE KEY-----\n...',
  'pages.ldap.tlsServername': 'Nome do Servidor SNI',
  'pages.ldap.tlsServernamePlaceholder':
    'Indicação do Nome do Servidor para TLS',
  'pages.ldap.enabled': 'Ativar Autenticação LDAP',
  'pages.ldap.enabledHelp':
    'Quando ativado, os usuários serão autenticados no servidor LDAP. Usuários já vinculados ao LDAP sempre utilizarão autenticação LDAP independentemente desta configuração.',
  'pages.ldap.testConnection': 'Testar Conexão',
  'pages.ldap.testSuccess': 'Teste de conexão LDAP realizado com sucesso',
  'pages.ldap.testFailed': 'Falha no teste de conexão LDAP',
  'pages.ldap.saveSuccess': 'Configuração LDAP salva com sucesso',
  'pages.ldap.saveFailed': 'Falha ao salvar configuração LDAP',
  'pages.ldap.createdAt': 'Criado em',
  'pages.ldap.updatedAt': 'Atualizado em',
};
